export default "__VITE_ASSET__D7HoqRjU__"